import React from "react";
import { useLocation } from "react-router-dom";
import { getSeoForPath } from "../SEO/seoConfig";
import "./FAQSection.css";

/**
 * Renders the FAQs for the current route.
 *
 * Reads the same `faqs` array that <SEOComponent> turns into FAQPage
 * structured data. Google requires FAQ markup to describe content that is
 * actually visible on the page — emitting the schema alone would be a
 * guidelines violation — so sharing one source keeps the two in step by
 * construction.
 *
 * Uses <details>/<summary> so the accordion works with no JavaScript, stays
 * keyboard-operable, and is expandable by the browser's find-in-page.
 */
function FAQSection() {
  const { pathname } = useLocation();
  const { faqs } = getSeoForPath(pathname);

  if (!faqs?.length) return null;

  return (
    <section className="faq" aria-labelledby="faq-heading">
      <div className="container">
        <h2 className="faq__heading" id="faq-heading">
          Frequently asked questions
        </h2>
        <div className="faq__list">
          {faqs.map((item) => (
            <details key={item.q} className="faq__item">
              <summary className="faq__question">{item.q}</summary>
              <p className="faq__answer">{item.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FAQSection;
